import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appearenceService from "./appearanceService";

const initialState = {
  fontStateLoading: false,
  fontStateSuccess: false,
  fontStateError: false,
  font:{
    fontColor: "",
      fontType: "",
  },
  fontStateErrorMsg: "",
};

// _______________________createFontSettings response function and services calling
export const createFontSettings = createAsyncThunk(
  "createFontSettings",
  async (data, thunkAPI) => {
    try {
      const response = await appearenceService.createFontSettings(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const fontSettingsSlice = createSlice({
  name: 'fontSettings',
  initialState,
  reducers: {
    resetFontSettings: (state) => {
      state.fontStateLoading = false;
      state.fontStateSuccess = false;
      state.fontStateError = false;
      state.fontStateErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFontSettings.pending, (state) => {
        state.fontStateLoading = true;
      })
      .addCase(createFontSettings.fulfilled, (state, action) => {
        state.fontStateLoading = false;
        state.fontStateSuccess = true;
        state.font = action.payload;
      })
      .addCase(createFontSettings.rejected, (state, action) => {
        state.fontStateLoading = false;
        state.fontStateError = true;
        state.fontStateErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetFontSettings } = fontSettingsSlice.actions;
export default fontSettingsSlice.reducer;